import React, {useState} from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useFetchOptions from "../hooks/use-fetch-options.js";
import {MaskDefault} from "../../../../utils/mask.js";
import InputForm from "../../../../components/input/input-form.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { laneOptions, sourceOptions } = useFetchOptions();

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form id="search-form">

                    <div className={"mb-6"}>
                        <InputDateTime
                            id="dtStart"
                            label="Data/hora inicial *"
                            selected={filters.dtStart ? new Date(filters.dtStart) : null}
                            onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>

                    <div className={"mb-6"}>
                        <InputDateTime
                            id="dtEnd"
                            label="Data/hora final *"
                            selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                            onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>

                    <div className={"mb-6"}>
                        <InputForm
                            label="Placa"
                            value={filters.plate}
                            mask={MaskDefault.plateNoRestrict}
                            onChange={({target}) => setFilters(prev => ({ ...prev, plate: target.value?.toUpperCase() }))}
                            instanceId="plate"
                            id="plate"
                            classNameWrapper={"w-full"}
                            autocomplete={'off'}
                        />
                    </div>

                    <div className={"mb-6"}>
                        <SelectComponent
                            label='Câmera'
                            isMulti={true}
                            wrapValues={true}
                            options={laneOptions}
                            value={filters.lane}
                            onChange={(value) => setFilters(prev => ({...prev, lane: value}))}
                            instanceId="lane"
                            classNameWrapper={"w-full"}
                        />
                    </div>

                    <div className={"mb-6"}>
                        <SelectComponent
                            label='Origem'
                            isMulti={false}
                            wrapValues={true}
                            options={sourceOptions}
                            value={filters.source}
                            onChange={(value) => setFilters(prev => ({...prev, source: value}))}
                            instanceId="source"
                            classNameWrapper={"w-full"}
                            isClearable={false}
                        />
                    </div>

                </form>
            </div>
        </>
    );
};

export default Filters;